//close-enquiry.js

import { throttle } from "lodash";
import React, { useEffect, useState } from "react";
// import config from "../../../config";
import client from "../../../clients";
import Toast from "../../../lib/toast";
import { getMemberhipPlans } from "../../../components/search-filter/helper/api";
import { isAuthenticated } from "../../../auth";
import { getMembershipPlanCount } from "../../membership-plans/helper/api";
import { formatDateTime, startLoader, stopLoader } from "../../../lib/utils";
import { getUsersList, getUsersListV2 } from "../../employees/helper/api";
import FlatPicker from 'flatpickr';
import { getTaxes } from "../../../core/helper/TaxApiCall";
import { closeEnquiry } from "../helper/api";
let flatpickr;
let timer;

const CloseEnquiry = (props) => {

  const [isUserDetailsOpen, setUserDetailsOpen] = useState(true);
  const [currentElementId, setCurrentElementId] = useState("");
  const pageSize = 1000;
  var [pageNo,setPageNo] = useState(1);
  // const [isApplyTaxes,setApplyTaxes] = useState(false);
  const [pageCount,setPageCount] = useState(0);
  const [total,setTotal] = useState(0);
  const [isRemainingAmountDue, setRemainingAmountDue] = useState(false);
  const [closeEnqDetails, setCloseEnqDetails] = useState({
    emergencyContactName: "",
    emergencyContactNumber: "",
    paymentDueDate:'',
    panNumber: "",
    aadharNumber: "",
    gstinNumber: "",
    invoiceDate: new Date(),
    membership: "",
    membershipDiscount: "",
    selectedTrainer: "",
    date: new Date(),
    surCharges: "",
    amountPaid: "",
    paymentMode: "Online",
    paymentSource: "",
    chequeNumber: "",
    bankName: "",
    upiId: "",
    comment: "",
    transactionID: ""
  });


const [taxes, setTaxes] = useState([]); // server taxes

const [billingInfo, setBillingInfo] = useState({
  baseAmount:0,
  taxableAmount:0,
  subTotal: 0,
  surCharges: 0,
  taxBreakup: [],   // CGST, SGST, etc
  totalTax: 0,
  payableAmount: 0,
  remainingAmount: 0
});
  const membershipTypes = ["GymWorkout", "PersonalTraining", "GroupEx", "LybertyMembership", "Package", "Campaign"];
  const [selectedMembershipType, setSelectedMembershipType] = useState("GymWorkout");
  const [taxType,setTaxType] = useState('');
  const [allMemberships, setAllMemberships] = useState([]);
  const [trainersList, setTrainersList] = useState([]);
  const [paymentSources, setPaymentSources] = useState({
    online: ["NEFT", "RTGS", "IMPS", "UPI", "Credit Card", "Debit Card", "Juice"],
    wallet: ["Paytm", "PhonePe", "Google Pay", "Amazon Pay"]
  });
  const [cardTypes, setCardTypes] = useState(["Visa", "Mastercard", "Zeta", "Rupay", "Amex", "Bajaj Finserv", "Tata Card"]);
  const [currentSource, setCurrentSource] = useState("");
  const [isButtonLock, setButtonLock] = useState(false);
  const [isMemberShipSpinnerLoader,setMemberShipSpinnerLoader] = useState(false); 
  const {user,token} = isAuthenticated();

  const selectMemberShipType = plan => e =>{
    setCloseEnqDetails(oldstate=>{
      return {
        ...oldstate,
        membership: "",
        selectedTrainer: ""
      }
    })
    setSelectedMembershipType(plan); 
    e.stopPropagation()
  }

  const applyInclusive = () =>{
    if(taxType == "inclusive-tax") setTaxType("")
    else setTaxType("inclusive-tax")
  }


  const cancelCloseEnquiry=event=>{
    setRemainingAmountDue(false)
  }

  const checkAndCloseEnquiry = event =>{
    if(billingInfo.remainingAmount>0){
      setRemainingAmountDue(true);
    }else{
      handleCloseEnquiry();
    }
  }

  const handleCloseEnquiry = async () =>{
    try{

      startLoader()
      setButtonLock(true);

      const payload = {
        emergencyContactName: closeEnqDetails.emergencyContactName,
        emergencyContactNumber: closeEnqDetails.emergencyContactNumber,
        paymentDueDate:closeEnqDetails.paymentDueDate,
        panNumber: closeEnqDetails.panNumber,
        aadharNumber: closeEnqDetails.aadharNumber,
        gstinNumber: closeEnqDetails.gstinNumber,
        invoiceDate: closeEnqDetails.invoiceDate,
        membershipplanId: closeEnqDetails.membership._id,
        membershipDiscount: closeEnqDetails.membership.membershipDiscount,
        trainerId: closeEnqDetails.selectedTrainer._id,
        date: closeEnqDetails.date,
        surCharges: closeEnqDetails.surCharges,
        amountPaid: closeEnqDetails.amountPaid,
        paymentMode: closeEnqDetails.paymentMode,
        paymentSource: closeEnqDetails.paymentSource,
        chequeNumber: closeEnqDetails.chequeNumber,
        bankName: closeEnqDetails.bankName,
        upiId: closeEnqDetails.upiId,
        comment: closeEnqDetails.comment,
        transactionID: closeEnqDetails.transactionID,
        globalComment:closeEnqDetails.globalComment,
        subTotal:billingInfo.subTotal,
        surCharges: billingInfo.surCharges,
        totalTax: billingInfo.totalTax,
        basePrice:closeEnqDetails.membership.packages[0].basePrice,
        rackRate:closeEnqDetails.membership.packages[0].rackRate,
        taxIDs:taxes.map(d=>d._id),
        payableAmount: billingInfo.payableAmount,
        remainingAmount: billingInfo.remainingAmount,
        baseAmount:billingInfo.baseAmount,
        taxType,
        closed_by_role:user.role
      };


      const response = await closeEnquiry(user._id,token,props.selectedUsers._id,payload);

      if(!response.error){
        new Toast({
          type:'success',
          message:"Enquiry closed successfully",
          duartion:3000
        })
        props.handleCloseModal();
        props.reload();
      }else{
        new Toast({
          type:'error',
          message:"Error closing the enquiry",
          duartion:3000
        })
      }

    }catch(error){
      new Toast({
        type:'error',
        message:"Error closing the enquiry",
        duartion:3000
      })
    }

    stopLoader()
    setButtonLock(false);
  }

  const applyTaxes = event =>{
    if(taxType == "additional-tax") setTaxType("")
    else setTaxType('additional-tax');
  }


  const GetAllTaxes = async () =>{
    try{
      const branchId = localStorage.getItem("branchId");
      const params = {
        branchId,
        noLimit:'noLimit'
      };
      const responses = await getTaxes(user._id,token,params);

      if(!responses.error){
        setTaxes(responses);
      }
    }catch(error){

    }
  }

  const GetUserParams = (req,res) =>{
    const branchId = localStorage.getItem("branchId");
		const params = {
			noLimit:'noLimit',
			branchIDs:[branchId],
			isAllUser:true,
			roles:[5,6,7,10,2]
		};


		return params;
	}

	const GetAllUser = async () =>{
		try{
			const params = GetUserParams();
			const response = await getUsersListV2(user._id,token,params);
			if(response.error){
			}else{
				setTrainersList(response)
			}
		}catch(error){

		}
	}

  const GetMembershipPlanParams=()=>{
    let params = {
      pageNo:pageNo,
      pageSize:pageSize,
      branchId:localStorage.getItem("branchId")
    };

    params.type = selectedMembershipType;


    


    return params;
  }


  const GetMembershipPlans = async (isReload) =>{
    try{

      const params = GetMembershipPlanParams();

      const response = await getMemberhipPlans(user._id,token,params);

      if(response.error){
        
      }else{
        setAllMemberships(isReload?response:[...allMemberships,...response]);
      }

    }catch(error){
      new Toast({
        type:'error',
        message:error,
        duration:3000
      })
    }
  }

  const handlePaymentMode = paymentMode => event =>{
    try{
      setCloseEnqDetails(oldstate=>{
        return {
          ...oldstate,
          paymentMode: paymentMode,
          paymentSource: "",
          chequeNumber: "",
          bankName: "",
          upiId: "",
          comment: "",
          transactionID: ""
        }
      })
    }catch(error){
      
    }
  }


   const GetMembershipPlanCount = async () =>{
     try{

      const params = GetMembershipPlanParams();
      delete params.pageNo;
      delete params.pageSize;



      const response = await getMembershipPlanCount(user._id,token,params);

      if(response.error){
        
      }else{
        setPageNo(1)
        setPageCount(Math.ceil(response.COUNT / pageSize))
        setTotal(response.COUNT)
      }

    }catch(error){
      new Toast({
        type:'error',
        message:error,
        duration:3000
      })
    }
   }


  const toggleUserDetails = () => {
    setUserDetailsOpen(!isUserDetailsOpen)
  }

  const toggleInputFields = (id) => event => {
    if(id == "invoice-date") return;

    if (currentElementId == id) {
      setCurrentElementId('')
    } else {
      setCurrentElementId(id);
      
      let element = document.getElementById(id);
      if (element) {
        element.focus();

        if(id == "enq-closing-date" || id == "invoice-date" || id == "payment-due-date"){
          handleSelectDate(id);
        }

      }

    }
  }

  const handleChange = (name, value) => event => {
    value = !value ? event.target.value : value; 
    if(timer){
      clearTimeout(timer);
      timer = null;
    }
    if(name == "membershipDiscount"){
      setCloseEnqDetails(oldstate=>{
        oldstate['membership'][name] = value
        return {
          ...oldstate
        }
      })

      timer = setTimeout(()=>{
        
        const rackRate = closeEnqDetails.membership.packages[0].rackRate || 0;
        const basePrice = closeEnqDetails.membership.packages[0].basePrice || 0;

        
        if(value){
          if((rackRate-parseInt(value))<basePrice){
            new Toast({
              type:'info',
              duration:3000,
              message:"Discount can't be less then base price"
            })
            setCloseEnqDetails(oldstate=>{
              oldstate['membership'][name] = rackRate - basePrice
              return {
                ...oldstate
              }
            })
          }
        }

        clearTimeout(timer);
        timer = null;

      },1000);
    }else{
      setCloseEnqDetails({
        ...closeEnqDetails,
        [name]: value
      });

      if(name == "amountPaid"){
        timer = setTimeout(()=>{
          if(value){
            if((parseFloat(value))>billingInfo.payableAmount){
              new Toast({
                type:'info',
                duration:3000,
                message:"Paid amount can't be more then payable amount"
              })
              setCloseEnqDetails(oldstate=>{
                oldstate['amountPaid'] = billingInfo.payableAmount
                return {
                  ...oldstate
                }
              })
            }
          }

          clearTimeout(timer);
          timer = null;

        },1000);
      }
    }
  }


  const handleSelectMembership = (membership) => {
    setCloseEnqDetails({
      ...closeEnqDetails,
      membership : {...membership,membershipDiscount:0}
    });
  }


  const selectTrainer = (trainer) => {
    setCloseEnqDetails({
      ...closeEnqDetails,
      selectedTrainer: trainer
    })
  }


  const handleSelectDate = (id) => {
    flatpickr = FlatPicker("#"+id, {
      disableMobile: true,
      onChange: (e) => {
        if(e.length>0) {
          if(new Date(e[0])<new Date(new Date().setHours(0,0,0,0))){
            return alert("Please note, selecting a previous date is not allowed. Kindly choose a current or future date");
          }
          setCloseEnqDetails(oldstate=>{
            const newState = {...oldstate};
            if(id == "invoice-date") newState.invoiceDate = e[0];
            else if(id == "payment-due-date") newState.paymentDueDate = e[0];
            else newState.date = e[0];
            return newState;
          });
        }
      }
    })
    flatpickr.open();
  }


  const handleSelectPaymentSource = (source) => {
    setCloseEnqDetails((oldState) => ({
      ...oldState,
      paymentSource: source
    }))
  }

  const handleSelectCard = (getCardType) => {
    setCloseEnqDetails((oldState) => ({
      ...oldState,
      cardType: getCardType
    }))
  }


  useEffect(()=>{
    GetAllTaxes();
    GetAllUser();
  },[])

  
  useEffect(async ()=>{
    try{
      await startLoader()

      await GetMembershipPlans(true);
      await GetMembershipPlanCount();
      
    }catch(error){
      
    }

    await stopLoader();
  },[selectedMembershipType]);

  useEffect(() => {
  if (!closeEnqDetails?.membership) return;

  const rackRate =
    closeEnqDetails.membership.packages[0].rackRate || 0;

    const discount =
      closeEnqDetails.membership.membershipDiscount || 0;

  const surchargePercent =
    closeEnqDetails.membership.surchargePercent ||
    closeEnqDetails.surCharges ||
    0;

  // 1️⃣ Base Subtotal
  let baseAmount = rackRate - discount;

  // 2️⃣ Surcharge
  const surCharges = (baseAmount * surchargePercent) / 100;

    let taxBreakup = [];
    let totalTax = 0;

  if (taxType && taxes.length) {
    const totalTaxPercent = taxes.reduce(
      (sum, t) => parseFloat(parseFloat(sum) + (parseFloat(t.value) || 0)),
      0
    );

    if (taxType == "inclusive-tax") {
      // ✅ Extract tax from amount
      const inclusiveTax =
        (baseAmount * totalTaxPercent) /
        (100 + totalTaxPercent);


      totalTax = inclusiveTax;

      taxBreakup = taxes.map(tax => {
        const amount =
          (inclusiveTax * tax.value) / totalTaxPercent;

        return {
          ...tax,
          amount: amount.toFixed(2)
        };
      });
    } else if(taxType == "additional-tax") {
      // ✅ Exclusive tax (normal add-on)
      taxBreakup = taxes.map(tax => {
        const amount =
          (baseAmount * tax.value) / 100;
        totalTax += amount;

        return {
          ...tax,
          amount: amount.toFixed(2)
        };
      });
    }
  }

  const taxableAmount = taxType == "inclusive-tax"
    ? baseAmount - totalTax
    : baseAmount;

  const subTotal = taxType != "additional-tax"
    ? baseAmount
    : baseAmount + totalTax;

  // 3️⃣ Payable
  const payableAmount =
    subTotal + surCharges;

  // 4️⃣ Remaining
  const remainingAmount =
    payableAmount -
    (closeEnqDetails.amountPaid || 0);

  setBillingInfo(prev => ({
    ...prev,
    taxBreakup,
    baseAmount,
    taxableAmount: Math.round(taxableAmount),
    subTotal: Math.round(subTotal),
    surCharges: Math.round(surCharges),
    payableAmount: Math.round(payableAmount),
    remainingAmount: Math.round(remainingAmount)
  }));

}, [closeEnqDetails,taxType, taxes]);

useEffect(()=>{
  if(closeEnqDetails.amountPaid && closeEnqDetails.invoiceDate && closeEnqDetails.date){
    if(selectedMembershipType == "PersonalTraining"){
      if(closeEnqDetails.selectedTrainer) setButtonLock(false)
      else setButtonLock(true);
    }else{
      setButtonLock(false)
    }
  }else{
    setButtonLock(true)
  }
},[closeEnqDetails,billingInfo,selectedMembershipType])


// useEffect(() => {
//   if (!closeEnqDetails?.membership) return;

//   const rackRate =
//     closeEnqDetails.membership.packages[0].rackRate || 0;

//   const discount =
//     closeEnqDetails.membership.membershipDiscount || 0;

//   const surchargePercent =
//     closeEnqDetails.membership.surchargePercent || closeEnqDetails.surCharges || 0;

//   // 1️⃣ Sub Total
//   let subTotal = rackRate - discount;

//   // 2️⃣ Surcharge
//   const surCharges = (subTotal * surchargePercent) / 100;

//   let taxBreakup = [];
//   let totalTax = 0;

//   if (isApplyTaxes && taxes.length) {
//     taxBreakup = taxes.map(tax => {
//       const amount = (subTotal * tax.value) / 100;
//       totalTax += amount;

//       return {
//         ...tax,
//         amount: ((amount * 100) / 100).toFixed(2)
//       };
//     });
//   }


//   const taxableAmount = subTotal;

//   subTotal = subTotal + totalTax;

//   // 3️⃣ Payable Amount
//   const payableAmount = taxableAmount + totalTax + surCharges;

//   // 4️⃣ Remaining Amount
//   const remainingAmount =
//     payableAmount - closeEnqDetails.amountPaid;

//   setBillingInfo(prev => ({
//     ...prev,
//     taxBreakup,
//     taxableAmount:Math.round(taxableAmount),
//     subTotal: Math.round(subTotal),
//     surCharges: Math.round(surCharges),
//     payableAmount: Math.round(payableAmount),
//     remainingAmount: Math.round(remainingAmount)
//   }));

// }, [closeEnqDetails,isApplyTaxes,taxes,isInclusiveTaxes]);







  const handleMembershipScroll = throttle(async (event) => {
    try {
      const { clientHeight, scrollTop, scrollHeight } = event.target;
      if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight - 5)) && pageNo < pageCount && !isMemberShipSpinnerLoader) {
        if (pageNo < pageCount) {
          pageNo = pageNo + 1;
          setPageNo(pageNo)
          setMemberShipSpinnerLoader(true);
          await GetMembershipPlans();
          setMemberShipSpinnerLoader(false)
        }
      }
    } catch (error) {
      setMemberShipSpinnerLoader(false)
    }
  }, 800);




  return(
    <div onTouchStart={(e)=>e.stopPropagation()} className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`} style={{borderRadius: window.innerWidth < 640 ? "12px 12px 0 0" : ""}}>
      <div className="modal-container flex-item" style={{width: window.innerWidth > 767 && "54%", height: window.innerWidth > 767 && "94%"}}>
        {
          window.innerWidth > 767 && (
            <div className="w-full d-flex space-between" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}>
              {/* <div className='d-flex'>
                <svg className='flex-item m-r-8' width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.75 6.62484C10.75 6.50328 10.7983 6.3867 10.8843 6.30074C10.9702 6.21479 11.0868 6.1665 11.2083 6.1665H12.125C12.2466 6.1665 12.3632 6.21479 12.4491 6.30074C12.535 6.3867 12.5833 6.50328 12.5833 6.62484V7.5415C12.5833 7.66306 12.535 7.77964 12.4491 7.8656C12.3632 7.95155 12.2466 7.99984 12.125 7.99984H11.2083C11.0868 7.99984 10.9702 7.95155 10.8843 7.8656C10.7983 7.77964 10.75 7.66306 10.75 7.5415V6.62484Z" fill="#ffffff"/>
                  <path d="M3.87435 0.666504C3.9959 0.666504 4.11249 0.714792 4.19844 0.800746C4.2844 0.886701 4.33268 1.00328 4.33268 1.12484V1.58317H11.666V1.12484C11.666 1.00328 11.7143 0.886701 11.8003 0.800746C11.8862 0.714792 12.0028 0.666504 12.1243 0.666504C12.2459 0.666504 12.3625 0.714792 12.4484 0.800746C12.5344 0.886701 12.5827 1.00328 12.5827 1.12484V1.58317H13.4993C13.9855 1.58317 14.4519 1.77632 14.7957 2.12014C15.1395 2.46396 15.3327 2.93027 15.3327 3.4165V13.4998C15.3327 13.986 15.1395 14.4524 14.7957 14.7962C14.4519 15.14 13.9855 15.3332 13.4993 15.3332H2.49935C2.01312 15.3332 1.54681 15.14 1.20299 14.7962C0.85917 14.4524 0.666016 13.986 0.666016 13.4998V3.4165C0.666016 2.93027 0.85917 2.46396 1.20299 2.12014C1.54681 1.77632 2.01312 1.58317 2.49935 1.58317H3.41602V1.12484C3.41602 1.00328 3.4643 0.886701 3.55026 0.800746C3.63621 0.714792 3.75279 0.666504 3.87435 0.666504ZM1.58268 4.33317V13.4998C1.58268 13.743 1.67926 13.9761 1.85116 14.148C2.02307 14.3199 2.25623 14.4165 2.49935 14.4165H13.4993C13.7425 14.4165 13.9756 14.3199 14.1475 14.148C14.3195 13.9761 14.416 13.743 14.416 13.4998V4.33317H1.58268Z" fill="#ffffff"/>
                </svg>
                <p className="flex-item fs-18 color-white">Close Enquiry</p>
              </div>
              <div onClick={props.handleCloseModal} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div> */}
            </div>
          )
        }
        <div className={`${window.innerWidth < 640 && "m-t-8"} w-full`} style={{height: window.innerWidth > 767 ? "88%" : "100%"}}>
          <div onClick={e => e.stopPropagation()} style={{ padding: window.innerWidth > 767 ? "0 12px 40px 12px" : "12px" }}>
            <div className="selected-enq-user-list-scroll-container slideTopToBottom bg-white" style={{height:"", maxHeight:"90%"}}>
              <div className="d-flex w-full space-between">
                <div className="d-flex">
                  {
                   (props.selectedUsers.user.length && props.selectedUsers.user[0].profileID)?(
                    <div className="table-item-profile d-flex flex-item">
                        <img className="flex-item" src={`${client.config.API_URL}/image/file/${props.selectedUsers.user[0].profileID}/30/30/70?${Date.now()}`} />
                    </div>
                   ):(
                    <div className="table-item-profile d-flex flex-item" style={{
                      backgroundColor: "#5d883c"
                    }}>
                      <p className='flex-item' style={{
                        color: "#ffffff",
                        margin: "0 auto",
                        fontSize: 14,
                      }}>{`${props.selectedUsers.user[0].name}`.trim()[0]}</p>
                    </div>
                    // <div className="table-item-profile d-flex flex-item">
                    //     <p></p>
                    // </div>
                   )
                  }
                  <div className="flex-item m-l-8">
                    <p className="color-black fs-16 font-weight-600" style={{lineHeight:"16px"}}>{props.selectedUsers.userInfo.full_name}</p>
                    <p className="color-grey-02 fs-10 m-t-6" style={{lineHeight:"10px"}}>{props.selectedUsers.userInfo.phone}</p>
                  </div>
                </div>
                <div onClick={()=>toggleUserDetails()} className="table-action-button d-flex flex-item" style={{backgroundColor: isUserDetailsOpen ? "#720B0B" : "#ffffff"}}>
                  <svg className="flex-item svg-stroke margin-auto" style={{transition:"180ms", transform: isUserDetailsOpen ? "rotate(180deg)" : "rotate(0deg)"}} width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.5 0.5L7 7.5L13.5 0.5" stroke={isUserDetailsOpen ? "#ffffff" : "#9A9A9A"} stroke-linecap="round"/>
                  </svg>
                </div>
              </div>
              {
                isUserDetailsOpen && (
                  <div className="w-full m-t-20 d-flex-wrap space-between">
                    <div onClick={toggleInputFields('emergency-contact-name')} className={`${currentElementId == "emergency-contact-name" || closeEnqDetails.emergencyContactName ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: currentElementId == "emergency-contact-name" || closeEnqDetails.emergencyContactName ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "49%" : "100%" }}>
                      <div className="flex-item d-flex">
                        <svg  className="flex-item m-r-6" width={currentElementId == "emergency-contact-name" || closeEnqDetails.emergencyContactName ? "12" : "16"}  height={currentElementId == "emergency-contact-name" || closeEnqDetails.emergencyContactName ? "12" : "16"} style={{ transition: "180ms" }} viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6 1.07143C6.5439 1.07143 7.07558 1.22852 7.52782 1.52285C7.98005 1.81717 8.33253 2.23551 8.54067 2.72496C8.74881 3.2144 8.80327 3.75297 8.69716 4.27256C8.59105 4.79216 8.32914 5.26943 7.94454 5.64404C7.55995 6.01864 7.06995 6.27375 6.5365 6.3771C6.00305 6.48046 5.45012 6.42741 4.94762 6.22468C4.44512 6.02194 4.01563 5.67862 3.71346 5.23813C3.41128 4.79765 3.25 4.27977 3.25 3.75C3.25 3.0396 3.53973 2.35829 4.05546 1.85596C4.57118 1.35363 5.27065 1.07143 6 1.07143ZM6 0C5.23854 0 4.49418 0.219934 3.86105 0.631989C3.22793 1.04404 2.73446 1.62971 2.44306 2.31494C2.15167 3.00016 2.07542 3.75416 2.22398 4.48159C2.37253 5.20902 2.73921 5.8772 3.27764 6.40165C3.81607 6.9261 4.50208 7.28325 5.2489 7.42794C5.99573 7.57264 6.76984 7.49838 7.47333 7.21455C8.17683 6.93072 8.77812 6.45007 9.20116 5.83339C9.6242 5.2167 9.85 4.49168 9.85 3.75C9.85 2.75544 9.44438 1.80161 8.72236 1.09835C8.00035 0.395088 7.02108 0 6 0ZM11.5 15H10.4V12.3214C10.4 11.9697 10.3289 11.6214 10.1907 11.2964C10.0525 10.9714 9.84991 10.6761 9.59454 10.4274C9.33918 10.1787 9.03603 9.98136 8.70238 9.84675C8.36873 9.71214 8.01114 9.64286 7.65 9.64286H4.35C3.62065 9.64286 2.92118 9.92506 2.40546 10.4274C1.88973 10.9297 1.6 11.611 1.6 12.3214V15H0.5V12.3214C0.5 11.3269 0.905624 10.373 1.62764 9.66978C2.34965 8.96652 3.32892 8.57143 4.35 8.57143H7.65C8.67108 8.57143 9.65035 8.96652 10.3724 9.66978C11.0944 10.373 11.5 11.3269 11.5 12.3214V15Z" fill={currentElementId == "emergency-contact-name" || closeEnqDetails.emergencyContactName ? "var(--darkBlue)" : "#6d6d6d"}/>
                        </svg>
                        <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "closeEnqDetails" || closeEnqDetails.emergencyContactName ? "10px" : "14px", color: currentElementId == "emergency-contact-name" || closeEnqDetails.emergencyContactName ? "var(--darkBlue)" : "", transition: "180ms" }}>Emergency Contact Name</p>
                      </div>
                      <input id="emergency-contact-name" value={closeEnqDetails.emergencyContactName} placeholder="Enter Name" onChange={handleChange("emergencyContactName")} className={`${currentElementId == "emergency-contact-name" || closeEnqDetails.emergencyContactName ? "active-input-field" : "inactive-input-field"}`} type="text" />
                    </div>
                    <div onClick={toggleInputFields('emergency-contact-phone')} className={`${currentElementId == "emergency-contact-phone" || closeEnqDetails.emergencyContactNumber ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: currentElementId == "emergency-contact-phone" || closeEnqDetails.emergencyContactNumber ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "49%" : "100%" }}>
                      <div className="flex-item d-flex">
                        <svg  className="flex-item m-r-6" width={currentElementId == "emergency-contact-phone" || closeEnqDetails.emergencyContactNumber ? "12" : "16"}  height={currentElementId == "emergency-contact-phone" || closeEnqDetails.emergencyContactNumber ? "12" : "16"} style={{ transition: "180ms" }} viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1.38594 4.93194C1.12884 3.31997 2.32597 1.86957 4.15474 1.33738C4.47945 1.24295 4.82984 1.26978 5.13443 1.4124C5.43903 1.55503 5.67489 1.8027 5.79389 2.10489L6.38031 3.59248C6.47459 3.83176 6.4915 4.09236 6.42886 4.34084C6.36621 4.58932 6.22688 4.81436 6.02873 4.98709L4.28431 6.50737C4.19812 6.58236 4.13389 6.67733 4.09793 6.78298C4.06197 6.88864 4.0555 7.00135 4.07916 7.1101L4.09468 7.17678L4.13787 7.34414C4.17634 7.4852 4.23437 7.68397 4.31603 7.92122C4.47798 8.3925 4.73644 9.026 5.12109 9.65887C5.50574 10.2917 5.95382 10.8214 6.30203 11.1901C6.48354 11.3819 6.67309 11.5667 6.87023 11.744L6.92422 11.7915C7.01147 11.8649 7.11725 11.9156 7.23126 11.9387C7.34526 11.9617 7.4636 11.9563 7.57475 11.9229L9.83271 11.2478C10.0893 11.1711 10.364 11.1691 10.6218 11.2418C10.8796 11.3146 11.1086 11.4589 11.2795 11.6562L12.3478 12.8886C12.7932 13.4016 12.7405 14.1556 12.2283 14.6089C10.8287 15.8484 8.90415 16.1029 7.5653 15.0796C5.92462 13.8215 4.5412 12.2878 3.48397 10.5546C2.41898 8.82209 1.70721 6.91499 1.38594 4.93194ZM5.49292 7.19409L6.94109 5.93221C7.3374 5.58676 7.61606 5.13668 7.74135 4.63972C7.86663 4.14276 7.83282 3.62157 7.64425 3.14299L7.05716 1.65541C6.81764 1.04764 6.3432 0.549531 5.73055 0.262636C5.11789 -0.0242588 4.41315 -0.0783456 3.75997 0.111401C1.48919 0.772479 -0.33418 2.70698 0.0518189 5.12366C0.398316 7.26649 1.16686 9.32804 2.3172 11.2003C3.45751 13.0693 4.94958 14.7233 6.71907 16.0798C8.72667 17.6123 11.4084 17.0897 13.1488 15.5476C13.6471 15.1068 13.9494 14.5019 13.9942 13.8564C14.039 13.2108 13.8228 12.5734 13.3897 12.0743L12.3215 10.8419C11.9796 10.4472 11.5214 10.1585 11.0057 10.013C10.49 9.86741 9.94032 9.8716 9.42714 10.025L7.55315 10.5854C7.46925 10.5034 7.38713 10.4199 7.30684 10.3347C6.92157 9.92994 6.58082 9.48886 6.28988 9.01831C6.00633 8.54356 5.77456 8.04254 5.59819 7.52303C5.56073 7.4143 5.52563 7.30484 5.49292 7.19474" fill={currentElementId == "emergency-contact-phone" || closeEnqDetails.emergencyContactNumber ? "var(--darkBlue)" : "#6d6d6d"}/>
                        </svg>
                        <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "closeEnqDetails" || closeEnqDetails.emergencyContactNumber ? "10px" : "14px", color: currentElementId == "emergency-contact-phone" || closeEnqDetails.emergencyContactNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>Emergency Contact Number</p>
                      </div>
                      <input id="emergency-contact-phone" value={closeEnqDetails.emergencyContactNumber} placeholder="Enter Number" onChange={handleChange("emergencyContactNumber")} className={`${currentElementId == "emergency-contact-phone" || closeEnqDetails.emergencyContactNumber ? "active-input-field" : "inactive-input-field"}`} type="number" />
                    </div>
                    <div onClick={toggleInputFields('pan-number')} className={`${currentElementId == "pan-number" || closeEnqDetails.panNumber ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == "pan-number" || closeEnqDetails.panNumber ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "23.2%" : "48%", marginBottom: window.innerWidth < 768 && "12px" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "pan-number" || closeEnqDetails.panNumber ? "10px" : "14px", color: currentElementId == "pan-number" || closeEnqDetails.panNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>PAN Number</p>
                      </div>
                      <input id="pan-number" value={closeEnqDetails.panNumber} placeholder="Enter PAN No." onChange={handleChange("panNumber")} className={`${currentElementId == "pan-number" || closeEnqDetails.panNumber ? "active-input-field" : "inactive-input-field"}`} type="text" />
                    </div>
                    <div onClick={toggleInputFields('aadhar-number')} className={`${currentElementId == "aadhar-number" || closeEnqDetails.aadharNumber ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == "aadhar-number" || closeEnqDetails.aadharNumber ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "23.2%" : "48%", marginBottom: window.innerWidth < 768 && "12px" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "aadhar-number" || closeEnqDetails.aadharNumber ? "10px" : "14px", color: currentElementId == "aadhar-number" || closeEnqDetails.aadharNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>Aadhar Number</p>
                      </div>
                      <input id="aadhar-number" value={closeEnqDetails.aadharNumber} placeholder="Enter Aadhar No." onChange={handleChange("aadharNumber")} className={`${currentElementId == "aadhar-number" || closeEnqDetails.aadharNumber ? "active-input-field" : "inactive-input-field"}`} type="text" />
                    </div>
                    <div onClick={toggleInputFields('gstin-number')} className={`${currentElementId == "gstin-number" || closeEnqDetails.gstinNumber ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == "gstin-number" || closeEnqDetails.gstinNumber ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "23.2%" : "48%"  }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "gstin-number" || closeEnqDetails.gstinNumber ? "10px" : "14px", color: currentElementId == "gstin-number" || closeEnqDetails.gstinNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>GSTIN Number</p>
                      </div>
                      <input id="gstin-number" value={closeEnqDetails.gstinNumber} placeholder="Enter GSTIN No." onChange={handleChange("gstinNumber")} className={`${currentElementId == "gstin-number" || closeEnqDetails.gstinNumber ? "active-input-field" : "inactive-input-field"}`} type="text" />
                    </div>
                    <div onClick={toggleInputFields('invoice-date')} className={`${currentElementId == "invoice-date" || closeEnqDetails.invoiceDate ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == "invoice-date" || closeEnqDetails.invoiceDate ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "23.2%" : "48%" }}>
                      <div className="flex-item d-flex">
                        <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "invoice-date" || closeEnqDetails.invoiceDate ? "10px" : "14px", color: currentElementId == "invoice-date" || closeEnqDetails.invoiceDate ? "var(--darkBlue)" : "", transition: "180ms" }}>Invoice Date *</p>
                      </div>
                      <input disabled id="invoice-date" value={formatDateTime(closeEnqDetails.invoiceDate)} placeholder="DD/MM/YYYY" className={`${currentElementId == "invoice-date" || closeEnqDetails.invoiceDate ? "active-input-field" : "inactive-input-field"}`} type="text" />
                    </div>
                  
                  </div>
                )
              }
            </div>
            <svg className="m-t-16 m-b-12" width="100%" height="2" viewBox="0 0 376 1" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="-0.00195312" y1="0.5" x2="376.001" y2="0.5" stroke="#BDBDBD" stroke-dasharray="4 4"/>
            </svg>
            


            {/* MEMBERSHIP PLANS */}

            <div className="enquiry-types-horizontal-scroll-container d-flex">
              {
                membershipTypes.map((plan, index) => {
                  return (
                    <div onClick={selectMemberShipType(plan)} className={`member-button-global btn-center d-flex m-r-12 ${selectedMembershipType == plan ? "global-blue-button-controller-active" : "member-button-global-inactive"}`} style={{ height:"40px", borderRadius:"20px",pointerEvents:'auto !important' }}>
                      <p className="flex-item fs-12" style={{whiteSpace:"nowrap", fontWeight: selectedMembershipType == plan && "700"}}>{plan}</p>
                    </div>
                  )
                })
              }
            </div>

            <div className="membership-selection-container m-t-8 flex-item m-b-12" onScroll={handleMembershipScroll}>
              {
                window.innerWidth < 768 ? (
                  allMemberships.map((membership, index) => {
                    return [
                      <div className="d-flex space-between">
                        <div onClick={()=>handleSelectMembership(membership)} className="d-flex" style={{width: closeEnqDetails.membership.Name == membership.Name ? "55%" : "100%"}}>
                          <input type="radio" name="membership" style={{alignSelf:"flex-start", width:"16px", height:"16px"}} checked={closeEnqDetails.membership.Name == membership.Name ? true : false} />
                          <div className="m-l-8" style={{alignSelf:"flex-start", width:"90%"}}>
                            <p className="fs-16 color-dark-blue font-weight-700" style={{marginTop:"-3px"}}>{closeEnqDetails.membership.Name != membership.Name ? membership.Name : membership.Name.slice(0, 12) + "..."}</p>
                            <p>Duration - <span className="font-weight-700">{membership.Duration}</span></p>
                            <p>Cost - <span className="font-weight-700">{membership.Cost}</span></p>
                          </div>
                        </div>
                        {
                          closeEnqDetails.membership.Name == membership.Name && (
                            <div onClick={toggleInputFields('membership-discount')} className={`${currentElementId == "membership-discount" || closeEnqDetails.membershipDiscount ? "member-global-input-field" : "member-global-input-field d-flex"} w-full`} style={{ border: currentElementId == "membership-discount" || closeEnqDetails.membershipDiscount ? "1px solid var(--darkBlue)" : "", alignSelf:"flex-start", width:"40%" }}>
                              <div className="flex-item d-flex">
                                <svg className="flex-item m-r-6" width={currentElementId == "membership-discount" || closeEnqDetails.membershipDiscount ? "12" : "16"}  height={currentElementId == "membership-discount" || closeEnqDetails.membershipDiscount ? "12" : "16"} style={{ transition: "180ms" }} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M11 6.5C11 6.3674 11.0527 6.24021 11.1465 6.14644C11.2402 6.05268 11.3674 6 11.5 6H12.5C12.6326 6 12.7598 6.05268 12.8535 6.14644C12.9473 6.24021 13 6.3674 13 6.5V7.5C13 7.6326 12.9473 7.75979 12.8535 7.85356C12.7598 7.94732 12.6326 8 12.5 8H11.5C11.3674 8 11.2402 7.94732 11.1465 7.85356C11.0527 7.75979 11 7.6326 11 7.5V6.5Z" fill={currentElementId == "membership-discount" || closeEnqDetails.membershipDiscount ? "var(--darkBlue)" : "#6d6d6d"}/>
                                  <path d="M3.5 0C3.6326 0 3.75979 0.0526784 3.85356 0.146446C3.94732 0.240215 4 0.367392 4 0.5V1H12V0.5C12 0.367392 12.0527 0.240215 12.1465 0.146446C12.2402 0.0526784 12.3674 0 12.5 0C12.6326 0 12.7598 0.0526784 12.8535 0.146446C12.9473 0.240215 13 0.367392 13 0.5V1H14C14.5304 1 15.0391 1.21071 15.4142 1.58579C15.7892 1.96086 16 2.46956 16 3V14C16 14.5304 15.7892 15.0391 15.4142 15.4142C15.0391 15.7892 14.5304 16 14 16H2C1.46956 16 0.960862 15.7892 0.585787 15.4142C0.210714 15.0391 0 14.5304 0 14V3C0 2.46956 0.210714 1.96086 0.585787 1.58579C0.960862 1.21071 1.46956 1 2 1H3V0.5C3 0.367392 3.05268 0.240215 3.14644 0.146446C3.24021 0.0526784 3.3674 0 3.5 0ZM1 4V14C1 14.2652 1.10536 14.5196 1.29289 14.7071C1.48043 14.8947 1.73478 15 2 15H14C14.2652 15 14.5196 14.8947 14.7071 14.7071C14.8947 14.5196 15 14.2652 15 14V4H1Z" fill={currentElementId == "membership-discount" || closeEnqDetails.membershipDiscount ? "var(--darkBlue)" : "#6d6d6d"}/>
                                </svg>
                                <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "membership-discount" || closeEnqDetails.membershipDiscount ? "10px" : "14px", color: currentElementId == "membership-discount" || closeEnqDetails.membershipDiscount ? "var(--darkBlue)" : "", transition: "180ms" }}>Discount</p>
                              </div>
                              <div className={`${currentElementId == "membership-discount" || closeEnqDetails.membershipDiscount ? "active-input-field" : "inactive-input-field"} d-flex`}>
                                <p className="flex-item m-r-4">₹</p>
                                <input className="flex-item" id="membership-discount" value={closeEnqDetails.membershipDiscount} placeholder="0.0" onChange={handleChange("membershipDiscount")} style={{width:"60%"}} type="text" />
                              </div>
                            </div>
                          )
                        }
                      </div>,
                      allMemberships.length != index + 1 && (
                        <div className="margin-auto m-t-12 m-b-12" style={{width:"100%", height:"1.5px", background:"#ffffff"}} />
                      )
                    ]
                  })
                ) : (
                  <div className="w-full">
                    <div className="d-flex w-full space-between">
                      <p className="flex-item fs-14 font-weight-700 color-dark-blue" style={{width:"45%"}}>Name</p>
                      <div className="flex-item" style={{width:"15%", textAlign:"center"}}>
                        <p className="fs-14 font-weight-700 color-dark-blue">Duration</p>
                      </div>
                      <div className="flex-item" style={{width:"15%", textAlign:"center"}}>
                        <p className="fs-14 font-weight-700 color-dark-blue">Cost</p>
                      </div>
                      <div className="flex-item" style={{width:"15%", textAlign:"center"}}>
                        <p className="fs-14 font-weight-700 color-dark-blue">Discount</p>
                      </div>
                    </div>
                    <div className="m-t-8 m-b-8" style={{width:"100%", height:"1px", background:"#e0e0e0"}} />
                    {
                      allMemberships.map((membership, index) => {
                        return(
                          <div className="d-flex w-full space-between m-b-16">
                            <div onClick={()=>handleSelectMembership(membership)} className="d-flex" style={{width:"45%"}}>
                              <input type="radio" name="membership" style={{alignSelf:"flex-start", width:"16px", height:"16px"}} checked={closeEnqDetails.membership && closeEnqDetails.membership._id == membership._id} />
                              <div className="m-l-8" style={{alignSelf:"flex-start", width:"90%"}}>
                                <p className="fs-16 color-dark-blue font-weight-700" style={{marginTop:"-3px"}}>{membership.name}</p>
                              </div>
                            </div>
                            <div className="flex-item" style={{width:"15%", textAlign:"center"}}>
                              <p><span className="font-weight-700">{membership.packages.length && membership.packages[0].duration}</span></p>
                            </div>
                            <div className="flex-item" style={{width:"15%", textAlign:"center"}}>
                              <p><span className="font-weight-700">{membership.packages.length && membership.packages[0].rackRate}</span></p>
                            </div>
                            <div className="flex-item" style={{width:"15%", textAlign:"center"}}>
                              {
                                closeEnqDetails.membership._id == membership._id && (                                
                                  <div className={`${currentElementId == "membership-discount" || closeEnqDetails.membership.membershipDiscount ? "member-global-input-field" : "member-global-input-field"} d-flex w-full`} style={{ border: currentElementId == "membership-discount" || closeEnqDetails.membership.membershipDiscount ? "1px solid var(--darkBlue)" : "", alignSelf:"flex-start", height:"40px" }}>
                                    <p className="flex-item m-r-4">₹</p>
                                    <input className="flex-item" id="membership-discount" value={closeEnqDetails.membership.membershipDiscount} placeholder="0.0" onChange={handleChange("membershipDiscount")} style={{width:"90%", textAlign:"center"}} type="text" />
                                  </div>
                                )
                              }
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                )
              }
              {isMemberShipSpinnerLoader && <div className="loader-5 center"><span></span></div>}
            </div>
            <div className="d-flex-wrap space-between">
              <div onClick={toggleInputFields('trainer')} className={`${currentElementId == "trainer" || closeEnqDetails.selectedTrainer ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "trainer" || closeEnqDetails.selectedTrainer) ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "48%" : "100%" }}>
                <div className="flex-item d-flex" style={{marginTop: (currentElementId == "trainer" || closeEnqDetails.selectedTrainer) ? "4px" : ""}}>
                  <svg className="flex-item m-r-4" width={(currentElementId == "trainer" || closeEnqDetails.selectedTrainer) ? "14" : "24"} height={(currentElementId == "trainer" || closeEnqDetails.selectedTrainer) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 4.07143C10.5439 4.07143 11.0756 4.22852 11.5278 4.52285C11.9801 4.81717 12.3325 5.23551 12.5407 5.72496C12.7488 6.2144 12.8033 6.75297 12.6972 7.27256C12.5911 7.79216 12.3291 8.26943 11.9445 8.64404C11.5599 9.01864 11.0699 9.27375 10.5365 9.3771C10.0031 9.48046 9.45012 9.42741 8.94762 9.22468C8.44512 9.02194 8.01563 8.67862 7.71346 8.23813C7.41128 7.79765 7.25 7.27977 7.25 6.75C7.25 6.0396 7.53973 5.35829 8.05546 4.85596C8.57118 4.35363 9.27065 4.07143 10 4.07143ZM10 3C9.23854 3 8.49418 3.21993 7.86105 3.63199C7.22793 4.04404 6.73446 4.62971 6.44306 5.31494C6.15167 6.00016 6.07542 6.75416 6.22398 7.48159C6.37253 8.20902 6.73921 8.8772 7.27764 9.40165C7.81607 9.9261 8.50208 10.2833 9.2489 10.4279C9.99573 10.5726 10.7698 10.4984 11.4733 10.2145C12.1768 9.93072 12.7781 9.45007 13.2012 8.83339C13.6242 8.2167 13.85 7.49168 13.85 6.75C13.85 5.75544 13.4444 4.80161 12.7224 4.09835C12.0003 3.39509 11.0211 3 10 3ZM15.5 18H14.4V15.3214C14.4 14.9697 14.3289 14.6214 14.1907 14.2964C14.0525 13.9714 13.8499 13.6761 13.5945 13.4274C13.3392 13.1787 13.036 12.9814 12.7024 12.8468C12.3687 12.7121 12.0111 12.6429 11.65 12.6429H8.35C7.62065 12.6429 6.92118 12.9251 6.40546 13.4274C5.88973 13.9297 5.6 14.611 5.6 15.3214V18H4.5V15.3214C4.5 14.3269 4.90562 13.373 5.62764 12.6698C6.34965 11.9665 7.32892 11.5714 8.35 11.5714H11.65C12.6711 11.5714 13.6503 11.9665 14.3724 12.6698C15.0944 13.373 15.5 14.3269 15.5 15.3214V18Z" fill={(currentElementId == "trainer" || closeEnqDetails.selectedTrainer) ? "var(--darkBlue)" : "#6d6d6d"}/>
                  </svg>
                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "trainer" || closeEnqDetails.selectedTrainer) ? "10px" : "16px", lineHeight: (currentElementId == "trainer" || closeEnqDetails.selectedTrainer) ? "10px" : "16px", color: (currentElementId == "trainer" || closeEnqDetails.selectedTrainer) ? "var(--darkBlue)" : "", transition: "180ms" }}>Trainer{selectedMembershipType == "PersonalTraining"?" *":""}</p>
                </div>
                <div className='input-field-arrow-dropdown' style={{ margin: "15px 12px 4px 0", transition: "180ms" }}>
                  <svg className="flex-item" style={{ transform: currentElementId == "trainer" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                  </svg>
                </div>
                {
                  closeEnqDetails.selectedTrainer ? (
                    <div className="w-full d-flex m-t-4 m-b-8">
                      <div className="flex-item">
                        <p className="font-weight-600 fs-16" style={{lineHeight:"16px"}}>{closeEnqDetails.selectedTrainer.name}</p>
                      </div>
                    </div>

                  ) : <p id="trainer" className={`flex-item color-grey-04 fs-14 m-t-24 ${(currentElementId == "trainer" || closeEnqDetails.selectedTrainer) ? "active-input-field" : "inactive-input-field"}`}>Select Trainer{selectedMembershipType == "PersonalTraining"?" *":""}</p>
                }
                
                {
                  currentElementId == "trainer" && (
                    <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", marginTop : closeEnqDetails.selectedTrainer && "70px"}}>
                      <div onClick={e => e.stopPropagation()} className="w-full" style={{padding:"8px", backgroundColor:"#f5f5f5", position:"sticky", top:0}}>
                        <div className="search-container d-flex space-between" style={{width:"100%",background:"#ffffff"}}>
                          <div className="d-flex w-full">
                            <svg className="flex-item m-r-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M21 21L16.657 16.657M16.657 16.657C17.3999 15.9141 17.9892 15.0322 18.3912 14.0615C18.7933 13.0909 19.0002 12.0506 19.0002 11C19.0002 9.9494 18.7933 8.90908 18.3913 7.93845C17.9892 6.96782 17.3999 6.08589 16.657 5.343C15.9141 4.60011 15.0322 4.01082 14.0616 3.60877C13.0909 3.20673 12.0506 2.99979 11 2.99979C9.94942 2.99979 8.90911 3.20673 7.93848 3.60877C6.96785 4.01082 6.08591 4.60011 5.34302 5.343C3.84269 6.84333 2.99982 8.87821 2.99982 11C2.99982 13.1218 3.84269 15.1567 5.34302 16.657C6.84335 18.1573 8.87824 19.0002 11 19.0002C13.1218 19.0002 15.1567 18.1573 16.657 16.657Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <input type="text" placeholder={`Search Trainer by “Name“`} className="flex-item search-input" style={{width:"85%"}} />
                          </div>
                        </div>
                      </div>
                      <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                        {
                          trainersList.map((trainer, index) => {
                            return (
                              <div onClick={()=>selectTrainer(trainer)} className="global-input-field-arrow-dropdown-item d-flex">
                                {/* <div className="pt-trainer-profile d-flex m-r-8">
                                  <img className="flex-item margin-auto" src={'https://picsum.photos/id/4/200/300'} />
                                </div> */}
                                {
                                  trainer.profileID ? (
                                    <div className="pt-trainer-profile d-flex m-r-8">
                                      <img className="flex-item margin-auto" src={`${client.config.API_URL}/image/file/${trainer.profileID}/auto/auto/70`} />
                                    </div>
                                    // <img className='flex-item user-profile m-r-8' src={`${client.config.API_URL}/image/file/${userData.profileID}/auto/auto/70`} />
                                  ) : (
                                    <div className="pt-trainer-profile d-flex m-r-8" style={{
                                      backgroundColor: '#5d883c'
                                    }}>
                                      <p className='flex-item' style={{
                                        color: '#ffffff',
                                        fontSize: 14,
                                        margin: '0 auto'
                                      }}>
                                        {`${trainer.name}`.trim()[0]}
                                      </p>
                                    </div>
                                  )
                                }
                                <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{trainer.name}</p>
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  )
                }
              </div>
              <div onClick={toggleInputFields('enq-closing-date')} className={`${currentElementId == "enq-closing-date" || closeEnqDetails.date ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: currentElementId == "enq-closing-date" || closeEnqDetails.date ? "1px solid var(--darkBlue)" : "", width: window.innerWidth > 767 ? "48%" : "100%" }}>
                <div className="flex-item d-flex">
                  <svg className="flex-item m-r-6" width={currentElementId == "enq-closing-date" || closeEnqDetails.date ? "12" : "16"}  height={currentElementId == "enq-closing-date" || closeEnqDetails.date ? "12" : "16"} style={{ transition: "180ms" }} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 6.5C11 6.3674 11.0527 6.24021 11.1465 6.14644C11.2402 6.05268 11.3674 6 11.5 6H12.5C12.6326 6 12.7598 6.05268 12.8535 6.14644C12.9473 6.24021 13 6.3674 13 6.5V7.5C13 7.6326 12.9473 7.75979 12.8535 7.85356C12.7598 7.94732 12.6326 8 12.5 8H11.5C11.3674 8 11.2402 7.94732 11.1465 7.85356C11.0527 7.75979 11 7.6326 11 7.5V6.5Z" fill={currentElementId == "enq-closing-date" || closeEnqDetails.date ? "var(--darkBlue)" : "#6d6d6d"}/>
                    <path d="M3.5 0C3.6326 0 3.75979 0.0526784 3.85356 0.146446C3.94732 0.240215 4 0.367392 4 0.5V1H12V0.5C12 0.367392 12.0527 0.240215 12.1465 0.146446C12.2402 0.0526784 12.3674 0 12.5 0C12.6326 0 12.7598 0.0526784 12.8535 0.146446C12.9473 0.240215 13 0.367392 13 0.5V1H14C14.5304 1 15.0391 1.21071 15.4142 1.58579C15.7892 1.96086 16 2.46956 16 3V14C16 14.5304 15.7892 15.0391 15.4142 15.4142C15.0391 15.7892 14.5304 16 14 16H2C1.46956 16 0.960862 15.7892 0.585787 15.4142C0.210714 15.0391 0 14.5304 0 14V3C0 2.46956 0.210714 1.96086 0.585787 1.58579C0.960862 1.21071 1.46956 1 2 1H3V0.5C3 0.367392 3.05268 0.240215 3.14644 0.146446C3.24021 0.0526784 3.3674 0 3.5 0ZM1 4V14C1 14.2652 1.10536 14.5196 1.29289 14.7071C1.48043 14.8947 1.73478 15 2 15H14C14.2652 15 14.5196 14.8947 14.7071 14.7071C14.8947 14.5196 15 14.2652 15 14V4H1Z" fill={currentElementId == "enq-closing-date" || closeEnqDetails.date ? "var(--darkBlue)" : "#6d6d6d"}/>
                  </svg>
                  <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "enq-closing-date" || closeEnqDetails.date ? "10px" : "14px", color: currentElementId == "enq-closing-date" || closeEnqDetails.date ? "var(--darkBlue)" : "", transition: "180ms" }}>Start Date *</p>
                </div>
                <input id="enq-closing-date" value={formatDateTime(closeEnqDetails.date)} placeholder="DD/MM/YYYY" onChange={handleChange("date")} className={`${currentElementId == "enq-closing-date" || closeEnqDetails.date ? "active-input-field" : "inactive-input-field"}`} type="text" />
              </div>
            </div>
            
            {
              closeEnqDetails.membership != "" && (
                <div className="w-full h-full">

                  <svg className="w-full m-b-16" width="100%" height={window.innerWidth > 767 ? "4" : "2"} viewBox="0 0 376 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line x1="-0.00195312" y1="0.996094" x2="376.001" y2="0.996094" stroke="#BDBDBD" stroke-dasharray="4 4"/>
                  </svg>

                  <div className="w-full h-full d-flex-wrap space-between">
                   
                    {/* PAYMENT MODE */}
                    <div className="space-between d-flex" style={{width: window.innerWidth > 767 ? "48%" : "100%", height:"67%", flexDirection:"column", alignSelf:"flex-start"}}>
                      <div className="w-full" style={{alignSelf:"flex-start"}}>
                        <div className="w-full d-flex">
                          <p className={`${window.innerWidth < 768 ? "margin-auto fs-16" : "fs-18"} font-weight-700 color-dark-blue m-b-8`}>Payment Mode</p>
                        </div>
                        <div className="d-flex flex-item w-full space-between m-b-12">
                          <div onClick={handlePaymentMode("Online")} className="flex-item d-flex">
                            <input type="radio" name="payment-mode" className="flex-item m-r-4" checked={closeEnqDetails.paymentMode == "Online"} />
                            <p className={`${closeEnqDetails.paymentMode == "Online" ? "color-dark-blue font-weight-600" : "color-grey-06"} flex-item fs-12`}>Online</p>
                          </div>
                          <div onClick={handlePaymentMode("Wallet")} className="flex-item d-flex">
                            <input type="radio" name="payment-mode" className="flex-item m-r-4" checked={closeEnqDetails.paymentMode == "Wallet"} />
                            <p className={`${closeEnqDetails.paymentMode == "Wallet" ? "color-dark-blue font-weight-600" : "color-grey-06"} flex-item fs-12`}>Wallet</p>
                          </div>
                          <div onClick={handlePaymentMode("Cheque")} className="flex-item d-flex">
                            <input type="radio" name="payment-mode" className="flex-item m-r-4" checked={closeEnqDetails.paymentMode == "Cheque"} />
                            <p className={`${closeEnqDetails.paymentMode == "Cheque" ? "color-dark-blue font-weight-600" : "color-grey-06"} flex-item fs-12`}>Cheque</p>
                          </div>
                          <div onClick={handlePaymentMode("Cash")} className="flex-item d-flex">
                            <input type="radio" name="payment-mode" className="flex-item m-r-4" checked={closeEnqDetails.paymentMode == "Cash"}/>
                            <p className={`${closeEnqDetails.paymentMode == "Cash" ? "color-dark-blue font-weight-600" : "color-grey-06"} flex-item fs-12`}>Cash</p>
                          </div>
                          <div onClick={handlePaymentMode("Other")} className="flex-item d-flex">
                            <input type="radio" name="payment-mode" className="flex-item m-r-4" checked={closeEnqDetails.paymentMode == "Other"}/>
                            <p className={`${closeEnqDetails.paymentMode == "Other" ? "color-dark-blue font-weight-600" : "color-grey-06"} flex-item fs-12`}>Other</p>
                          </div>
                        </div>
                        {
                          (closeEnqDetails.paymentMode == "Online" || closeEnqDetails.paymentMode == "Wallet") && (
                            <div className="w-full">
                              <div onClick={toggleInputFields('paymentSource')} className={`${currentElementId == "paymentSource" || closeEnqDetails.paymentSource ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == "paymentSource" || closeEnqDetails.paymentSource) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px", width:"100%" }}>
                                <div className="flex-item d-flex" style={{marginTop: (currentElementId == "paymentSource" || closeEnqDetails.paymentSource) ? "4px" : ""}}>
                                  <svg className="flex-item m-r-4" width={(currentElementId == "paymentSource" || closeEnqDetails.paymentSource) ? "14" : "24"} height={(currentElementId == "paymentSource" || closeEnqDetails.paymentSource) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13.5 12.423C12.936 12.423 12.4617 12.2307 12.077 11.846C11.6924 11.4613 11.5 10.987 11.5 10.423C11.5 9.859 11.6924 9.38467 12.077 9C12.4617 8.61533 12.936 8.423 13.5 8.423C14.064 8.423 14.5384 8.61533 14.923 9C15.3077 9.38467 15.5 9.859 15.5 10.423C15.5 10.987 15.3077 11.4613 14.923 11.846C14.5384 12.2307 14.064 12.423 13.5 12.423ZM7.30802 15.616C6.86335 15.616 6.48302 15.4577 6.16702 15.141C5.85035 14.8243 5.69202 14.444 5.69202 14V6.846C5.69202 6.402 5.85035 6.022 6.16702 5.706C6.48368 5.39 6.86368 5.23167 7.30702 5.231H19.692C20.1367 5.231 20.517 5.389 20.833 5.705C21.149 6.021 21.3074 6.40133 21.308 6.846V14C21.308 14.444 21.1497 14.824 20.833 15.14C20.517 15.4573 20.137 15.616 19.693 15.616H7.30802ZM8.30802 14.616H18.692C18.692 14.168 18.8504 13.7867 19.167 13.472C19.483 13.1573 19.863 13 20.307 13V7.846C19.8603 7.846 19.4797 7.688 19.165 7.372C18.8497 7.05533 18.692 6.675 18.692 6.231H8.30802C8.30802 6.67833 8.14968 7.05933 7.83302 7.374C7.51702 7.68867 7.13702 7.846 6.69302 7.846V13C7.13968 13 7.52068 13.1583 7.83602 13.475C8.15068 13.791 8.30802 14.171 8.30802 14.615M17.846 18.615H4.30802C3.86335 18.615 3.48302 18.457 3.16702 18.141C2.85035 17.8243 2.69202 17.444 2.69202 17V8.692C2.69202 8.55067 2.74002 8.432 2.83602 8.336C2.93202 8.24 3.05102 8.192 3.19302 8.192C3.33502 8.192 3.45368 8.24 3.54902 8.336C3.64435 8.432 3.69202 8.55067 3.69202 8.692V17C3.69202 17.1533 3.75602 17.2943 3.88402 17.423C4.01268 17.5517 4.15402 17.616 4.30802 17.616H17.846C17.988 17.616 18.1067 17.6637 18.202 17.759C18.298 17.855 18.346 17.974 18.346 18.116C18.346 18.258 18.298 18.3767 18.202 18.472C18.106 18.5673 17.9874 18.6143 17.846 18.615ZM7.30802 14.616H6.69202V6.23H7.30802C7.14135 6.23 6.99702 6.291 6.87502 6.413C6.75302 6.535 6.69202 6.679 6.69202 6.845V14C6.69202 14.1667 6.75302 14.311 6.87502 14.433C6.99702 14.555 7.14135 14.616 7.30802 14.616Z" fill={(currentElementId == "paymentSource" || closeEnqDetails.paymentSource) ? "var(--darkBlue)" : "#6d6d6d"}/>
                                  </svg>
                                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "paymentSource" || closeEnqDetails.paymentSource) ? "10px" : "16px", lineHeight: (currentElementId == "paymentSource" || closeEnqDetails.paymentSource) ? "10px" : "16px", color: (currentElementId == "paymentSource" || closeEnqDetails.paymentSource) ? "var(--darkBlue)" : "", transition: "180ms" }}>Payment is done via</p>
                                </div>
                                <div className='input-field-arrow-dropdown' style={{ margin: "18px 12px 4px 0", transition: "180ms" }}>
                                  <svg className="flex-item" style={{ transform: currentElementId == "paymentSource" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                  </svg>
                                </div>
                                <p id="paymentSource" className={`flex-item fs-16 m-t-24 ${(currentElementId == "paymentSource") ? "active-input-field color-grey-04" : closeEnqDetails.paymentSource ? "active-input-field" : "inactive-input-field"}`}>{closeEnqDetails.paymentSource ? closeEnqDetails.paymentSource : "Payment is done via"}</p>
                                
                                {
                                  currentElementId == "paymentSource" && (
                                    <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", marginTop : closeEnqDetails.paymentSource && "70px", padding: "0"}}>
                                      {
                                        closeEnqDetails.paymentMode == "Online" && (
                                          <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                                            {
                                              paymentSources.online.map((data, index) => {
                                                return (
                                                  <div onClick={()=>handleSelectPaymentSource(data)} className="global-input-field-arrow-dropdown-item d-flex">
                                                    <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data}</p>
                                                  </div>
                                                )
                                              })
                                            }
                                          </div>
                                        )
                                      }

                                      {
                                        closeEnqDetails.paymentMode == "Wallet" && (
                                          <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                                            {
                                              paymentSources.wallet.map((data, index) => {
                                                return (
                                                  <div onClick={()=>handleSelectPaymentSource(data)} className="global-input-field-arrow-dropdown-item d-flex">
                                                    <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data}</p>
                                                  </div>
                                                )
                                              })
                                            }
                                          </div>
                                        )
                                      }
                                    </div>
                                  )
                                }
                              </div>
                            </div>
                          )  
                        }

                        {
                          closeEnqDetails.paymentMode == "Cheque" && (
                            <div className="w-full">
                              <div onClick={toggleInputFields('cheque-number')} className={`${currentElementId == "cheque-number" || closeEnqDetails.chequeNumber ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "cheque-number" || closeEnqDetails.chequeNumber ? "1px solid var(--darkBlue)" : "" }}>
                                <div className="flex-item d-flex">
                                  <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "cheque-number" || closeEnqDetails.chequeNumber ? "10px" : "14px", color: currentElementId == "cheque-number" || closeEnqDetails.chequeNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>Cheque Number</p>
                                </div>
                                <div className={`${currentElementId == "cheque-number" || closeEnqDetails.chequeNumber ? "active-input-field" : "inactive-input-field"} d-flex m-t-22`}>
                                  <input className="flex-item" id="cheque-number" value={closeEnqDetails.chequeNumber} placeholder="Enter Cheque Number" onChange={handleChange("chequeNumber")} style={{width:"100%"}} type="text" />
                                </div>
                              </div>
                            </div>
                          ) 
                        }

                        {
                          (closeEnqDetails.paymentSource == "NEFT" || closeEnqDetails.paymentSource == "RTGS" || closeEnqDetails.paymentSource == "IMPS" ) && (
                            <div className="w-full">
                              <div onClick={toggleInputFields('bank-name')} className={`${currentElementId == "bank-name" || closeEnqDetails.bankName ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "bank-name" || closeEnqDetails.bankName ? "1px solid var(--darkBlue)" : "" }}>
                                <div className="flex-item d-flex">
                                  <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "bank-name" || closeEnqDetails.bankName ? "10px" : "14px", color: currentElementId == "bank-name" || closeEnqDetails.bankName ? "var(--darkBlue)" : "", transition: "180ms" }}>Bank Name</p>
                                </div>
                                <div className={`${currentElementId == "bank-name" || closeEnqDetails.bankName ? "active-input-field" : "inactive-input-field"} d-flex m-t-22`}>
                                  <input className="flex-item" id="bank-name" value={closeEnqDetails.bankName} placeholder="Enter Bank Name" onChange={handleChange("bankName")} style={{width:"100%"}} type="text" />
                                </div>
                              </div>
                            </div>
                          )
                        }

                        {
                          (closeEnqDetails.paymentSource == "Credit Card" || closeEnqDetails.paymentSource == "Debit Card") && (
                            <div onClick={toggleInputFields("card-type")} className={`${currentElementId == "card-type" || closeEnqDetails.cardType ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == "card-type" || closeEnqDetails.cardType) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px", width:"100%" }}>
                              <div className="flex-item d-flex" style={{marginTop: (currentElementId == "card-type" || closeEnqDetails.cardType) ? "4px" : ""}}>
                                <svg className="flex-item m-r-4" width={(currentElementId == "card-type" || closeEnqDetails.cardType) ? "14" : "24"} height={(currentElementId == "card-type" || closeEnqDetails.cardType) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M13.5 12.423C12.936 12.423 12.4617 12.2307 12.077 11.846C11.6924 11.4613 11.5 10.987 11.5 10.423C11.5 9.859 11.6924 9.38467 12.077 9C12.4617 8.61533 12.936 8.423 13.5 8.423C14.064 8.423 14.5384 8.61533 14.923 9C15.3077 9.38467 15.5 9.859 15.5 10.423C15.5 10.987 15.3077 11.4613 14.923 11.846C14.5384 12.2307 14.064 12.423 13.5 12.423ZM7.30802 15.616C6.86335 15.616 6.48302 15.4577 6.16702 15.141C5.85035 14.8243 5.69202 14.444 5.69202 14V6.846C5.69202 6.402 5.85035 6.022 6.16702 5.706C6.48368 5.39 6.86368 5.23167 7.30702 5.231H19.692C20.1367 5.231 20.517 5.389 20.833 5.705C21.149 6.021 21.3074 6.40133 21.308 6.846V14C21.308 14.444 21.1497 14.824 20.833 15.14C20.517 15.4573 20.137 15.616 19.693 15.616H7.30802ZM8.30802 14.616H18.692C18.692 14.168 18.8504 13.7867 19.167 13.472C19.483 13.1573 19.863 13 20.307 13V7.846C19.8603 7.846 19.4797 7.688 19.165 7.372C18.8497 7.05533 18.692 6.675 18.692 6.231H8.30802C8.30802 6.67833 8.14968 7.05933 7.83302 7.374C7.51702 7.68867 7.13702 7.846 6.69302 7.846V13C7.13968 13 7.52068 13.1583 7.83602 13.475C8.15068 13.791 8.30802 14.171 8.30802 14.615M17.846 18.615H4.30802C3.86335 18.615 3.48302 18.457 3.16702 18.141C2.85035 17.8243 2.69202 17.444 2.69202 17V8.692C2.69202 8.55067 2.74002 8.432 2.83602 8.336C2.93202 8.24 3.05102 8.192 3.19302 8.192C3.33502 8.192 3.45368 8.24 3.54902 8.336C3.64435 8.432 3.69202 8.55067 3.69202 8.692V17C3.69202 17.1533 3.75602 17.2943 3.88402 17.423C4.01268 17.5517 4.15402 17.616 4.30802 17.616H17.846C17.988 17.616 18.1067 17.6637 18.202 17.759C18.298 17.855 18.346 17.974 18.346 18.116C18.346 18.258 18.298 18.3767 18.202 18.472C18.106 18.5673 17.9874 18.6143 17.846 18.615ZM7.30802 14.616H6.69202V6.23H7.30802C7.14135 6.23 6.99702 6.291 6.87502 6.413C6.75302 6.535 6.69202 6.679 6.69202 6.845V14C6.69202 14.1667 6.75302 14.311 6.87502 14.433C6.99702 14.555 7.14135 14.616 7.30802 14.616Z" fill={(currentElementId == "card-type" || closeEnqDetails.cardType) ? "var(--darkBlue)" : "#6d6d6d"}/>
                                </svg>
                                <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "card-type" || closeEnqDetails.cardType) ? "10px" : "16px", lineHeight: (currentElementId == "card-type" || closeEnqDetails.cardType) ? "10px" : "16px", color: (currentElementId == "card-type" || closeEnqDetails.cardType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Payment is done via</p>
                              </div>
                              <div className='input-field-arrow-dropdown' style={{ margin: "18px 12px 4px 0", transition: "180ms" }}>
                                <svg className="flex-item" style={{ transform: currentElementId == "card-type" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                </svg>
                              </div>
                              <p id="card-type" className={`flex-item fs-16 m-t-24 ${(currentElementId == "card-type") ? "active-input-field color-grey-04" : closeEnqDetails.cardType ? "active-input-field" : "inactive-input-field"}`}>{closeEnqDetails.cardType ? closeEnqDetails.cardType : "Payment is done via"}</p>
                              
                              {
                                currentElementId == "card-type" && (
                                  <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", marginTop : closeEnqDetails.cardType && "70px"}}>
                                    <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                                      {
                                        cardTypes.map((data, index) => {
                                          return (
                                            <div onClick={()=>handleSelectCard(data)} className="global-input-field-arrow-dropdown-item d-flex">
                                              <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data}</p>
                                            </div>
                                          )
                                        })
                                      }
                                    </div>
                                  </div>
                                )
                              }
                            </div>
                          )
                        }

                        {
                          (closeEnqDetails.paymentSource == "Credit Card" || closeEnqDetails.paymentSource == "Debit Card") && (
                            <div onClick={toggleInputFields('approved-code')} className={`${currentElementId == "approved-code" || closeEnqDetails.approvedCode ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full`} style={{ border: currentElementId == "approved-code" || closeEnqDetails.approvedCode ? "1px solid var(--darkBlue)" : "" }}>
                              <div className="flex-item d-flex">
                                <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "approved-code" || closeEnqDetails.approvedCode ? "10px" : "14px", color: currentElementId == "approved-code" || closeEnqDetails.approvedCode ? "var(--darkBlue)" : "", transition: "180ms" }}>Approved Code</p>
                              </div>
                              <div className={`${currentElementId == "approved-code" || closeEnqDetails.approvedCode ? "active-input-field" : "inactive-input-field"} d-flex m-t-20`}>
                                <input className="flex-item" id="approved-code" value={closeEnqDetails.approvedCode} placeholder="Enter Approved Code" onChange={handleChange("approvedCode")} style={{width:"100%"}} type="text" />
                              </div>
                            </div>
                          )
                        }

                        {
                          (closeEnqDetails.paymentSource == "UPI") && (
                            <div onClick={toggleInputFields('upi-id')} className={`${currentElementId == "upi-id" || closeEnqDetails.upiId ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "upi-id" || closeEnqDetails.upiId ? "1px solid var(--darkBlue)" : "" }}>
                              <div className="flex-item d-flex">
                                <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "upi-id" || closeEnqDetails.upiId ? "10px" : "14px", color: currentElementId == "upi-id" || closeEnqDetails.upiId ? "var(--darkBlue)" : "", transition: "180ms" }}>Aadhaar No./Mobile No.</p>
                              </div>
                              <div className={`${currentElementId == "upi-id" || closeEnqDetails.upiId ? "active-input-field" : "inactive-input-field"} d-flex m-t-20`}>
                                <input className="flex-item" id="upi-id" value={closeEnqDetails.upiId} placeholder="Enter Aadhaar or Mobile No. or UPI ID" onChange={handleChange("upiId")} style={{width:"100%"}} type="text" />
                              </div>
                            </div>
                          )
                        }

                        {
                          closeEnqDetails.paymentSource == "Paytm" || closeEnqDetails.paymentSource == "PhonePe" || closeEnqDetails.paymentSource == "Google Pay" || closeEnqDetails.paymentSource == "Amazon Pay" && (
                            <div onClick={toggleInputFields('payment-number')} className={`${currentElementId == "payment-number" || closeEnqDetails.paymentNumber ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "payment-number" || closeEnqDetails.paymentNumber ? "1px solid var(--darkBlue)" : "" }}>
                              <div className="flex-item d-flex">
                                <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "payment-number" || closeEnqDetails.paymentNumber ? "10px" : "14px", color: currentElementId == "payment-number" || closeEnqDetails.paymentNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>Payment mobile number</p>
                              </div>
                              <div className={`${currentElementId == "payment-number" || closeEnqDetails.paymentNumber ? "active-input-field" : "inactive-input-field"} d-flex m-t-20`}>
                                <input className="flex-item" id="payment-number" value={closeEnqDetails.paymentNumber} placeholder="Enter payment mobile number" onChange={handleChange("paymentNumber")} style={{width:"100%"}} type="text" />
                              </div>
                            </div>
                          )
                        }

                        {
                          (closeEnqDetails.paymentSource == "NEFT" || closeEnqDetails.paymentSource == "RTGS" || closeEnqDetails.paymentSource == "IMPS" || closeEnqDetails.paymentSource == "UPI" || closeEnqDetails.paymentSource == "Juice" || closeEnqDetails.paymentSource == "Paytm" || closeEnqDetails.paymentSource == "PhonePe" || closeEnqDetails.paymentSource == "Google Pay" || closeEnqDetails.paymentSource == "Amazon Pay") && (
                            <div onClick={toggleInputFields('transaction-id')} className={`${currentElementId == "transaction-id" || closeEnqDetails.transactionID ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full`} style={{ border: currentElementId == "transaction-id" || closeEnqDetails.transactionID ? "1px solid var(--darkBlue)" : "" }}>
                              <div className="flex-item d-flex">
                                <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "transaction-id" || closeEnqDetails.transactionID ? "10px" : "14px", color: currentElementId == "transaction-id" || closeEnqDetails.transactionID ? "var(--darkBlue)" : "", transition: "180ms" }}>Transaction ID</p>
                              </div>
                              <div className={`${currentElementId == "transaction-id" || closeEnqDetails.transactionID ? "active-input-field" : "inactive-input-field"} d-flex m-t-20`}>
                                <input className="flex-item" id="transaction-id" value={closeEnqDetails.transactionID} placeholder="Enter Transaction ID" onChange={handleChange("transactionID")} style={{width:"100%"}} type="text" />
                              </div>
                            </div>
                          )
                        }


                        {
                          closeEnqDetails.paymentMode == "Other" && (
                            <div onClick={toggleInputFields('comment')} className={`${currentElementId == "comment" || closeEnqDetails.comment ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "comment" || closeEnqDetails.comment ? "1px solid var(--darkBlue)" : "" }}>
                              <div className="flex-item d-flex">
                                <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "comment" || closeEnqDetails.comment ? "10px" : "14px", color: currentElementId == "comment" || closeEnqDetails.comment ? "var(--darkBlue)" : "", transition: "180ms" }}>Comment *</p>
                              </div>
                              <div className={`${currentElementId == "comment" || closeEnqDetails.comment ? "active-input-field" : "inactive-input-field"} d-flex m-t-22`}>
                                <input className="flex-item" id="comment" value={closeEnqDetails.comment} placeholder="Enter Comment" onChange={handleChange("comment")} style={{width:"100%"}} type="text" />
                              </div>
                            </div>
                          )
                        }
                      </div>
                      <div onClick={toggleInputFields('global-comment')} className={`${currentElementId == "global-comment" || closeEnqDetails.globalComment ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "global-comment" || closeEnqDetails.globalComment ? "1px solid var(--darkBlue)" : "" }}>
                        <div className="flex-item d-flex">
                          <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "global-comment" || closeEnqDetails.globalComment ? "10px" : "14px", color: currentElementId == "global-comment" || closeEnqDetails.globalComment ? "var(--darkBlue)" : "", transition: "180ms" }}>Close Enquiry Comment</p>
                        </div>
                        <div className={`${currentElementId == "global-comment" || closeEnqDetails.globalComment ? "active-input-field" : "inactive-input-field"} d-flex m-t-22`}>
                          <input className="flex-item" id="global-comment" value={closeEnqDetails.globalComment} placeholder="Enter Enquiry Comment" onChange={handleChange("globalComment")} style={{width:"100%"}} type="text" />
                        </div>
                      </div>
                    </div>

                    {
                      window.innerWidth < 768 && (
                        <svg className="m-t-16 m-b-12" width="100%" height="2" viewBox="0 0 376 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <line x1="-0.00195312" y1="0.5" x2="376.001" y2="0.5" stroke="#BDBDBD" stroke-dasharray="4 4"/>
                        </svg>         
                      )
                    }  

                    {/* BILLING */}
                    <div style={{width: window.innerWidth > 767 ? "48%" : "100%", height: window.innerWidth > 767  && "67%"}}>
                      <div className="w-full d-flex">
                        <p className={`${window.innerWidth < 768 ? "margin-auto fs-16" : "fs-18"} font-weight-700 color-dark-blue m-b-12`}>Billing Summary</p>
                      </div>
                      <div className="billing-container bg-white">
                        <div className="d-flex space-between m-b-8">
                          <p className="flex-item color-grey-04">Selected Plans Total</p>
                          <p className="flex-item font-weight-700 color-grey-02">₹ {closeEnqDetails.membership.packages[0].rackRate}</p>
                        </div>
                        <div className="d-flex space-between m-b-8">
                          <p className="flex-item color-grey-04">Pool Charges</p>
                          <p className="flex-item font-weight-700 color-grey-02">₹ 0</p>
                        </div>
                        <div className="d-flex space-between m-b-20">
                          <p className="flex-item color-grey-04">Discount</p>
                          <p className="flex-item font-weight-700 color-grey-02">₹ {closeEnqDetails.membership.membershipDiscount}</p>
                        </div>
                        <div className="d-flex m-b-8">
                          <div className="d-flex flex-item">
                            <input onClick={applyInclusive} checked={taxType == "inclusive-tax"} className="flex-item m-r-6" type="checkbox" />
                            <p className="flex-item font-weight-700">Inclusive Tax</p>
                          </div>
                          <div className="d-flex flex-item m-l-8">
                            <input onClick={applyTaxes} checked={taxType == "additional-tax"} className="flex-item m-r-6" type="checkbox" />
                            <p className="flex-item font-weight-700">Additional Taxes</p>
                          </div>
                        </div>
                        <div className="d-flex space-between m-b-8">
                          <p className="flex-item color-grey-04">Taxable Amount</p>
                          <p className="flex-item font-weight-700 color-grey-02">₹ {billingInfo.taxableAmount}</p>
                        </div>
                       
                        {
                          taxType && <>
                          {
                            billingInfo.taxBreakup.map(tax=>{
                              return (
                                <div className="d-flex space-between m-b-8">
                                  <p className="flex-item color-grey-04">{tax.name} ( {tax.value} % )</p>
                                  <p className="flex-item font-weight-700 color-grey-02">₹ {tax.amount}</p>
                                </div>
                              )
                            })
                          }
                          </>
                        }
                        <div className="d-flex space-between m-b-8">
                          <p className="flex-item color-grey-04">Sub Total</p>
                          <p className="flex-item font-weight-700 color-grey-02">₹ {billingInfo.subTotal}</p>
                        </div>
                        <div className="d-flex space-between m-b-12">
                          <p className="flex-item color-grey-04">Surcharges</p>
                          <input className="flex-item" value={closeEnqDetails.surCharges} onInput={handleChange("surCharges")} placeholder="0 %" style={{border:"1px solid var(--darkBlue)", borderRadius:'4px', width:"80px", height:"30px", color:"#0088DA", textAlign:"center", fontWeight:"700"}} type="number" max={100} min={1} />
                        </div>
                        <svg className="flex-item m-b-12" width="100%" height="2" viewBox="0 0 360 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <line y1="1" x2="360" y2="1" stroke="#B4B4B4" stroke-dasharray="2 2"/>
                        </svg>
                        <div className="d-flex space-between m-b-8">
                          <p className="flex-item color-grey-04">Payable Amount</p>
                          <p className="flex-item font-weight-700 color-green">₹ {billingInfo.payableAmount}</p>
                        </div>
                        <div className="d-flex space-between m-b-8">
                          <p className="flex-item color-grey-04">Amount Paid</p>
                          <input className="flex-item" value={closeEnqDetails.amountPaid} onInput={handleChange("amountPaid")} placeholder="₹ 0.0" style={{border:"1px solid var(--darkBlue)", borderRadius:'4px', width:"80px", height:"30px", color:"#0088DA", textAlign:"center", fontWeight:"700"}} type="number" />
                        </div>
                        <div className="d-flex space-between">
                          <p className="flex-item color-grey-04">Remaining Amount</p>
                          <p className="flex-item font-weight-700 color-red">₹ {billingInfo.remainingAmount}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {
                    isRemainingAmountDue ? (
                      <div className="bottom-action-button">
                        <div className="balance-due-alert-container">
                          <div className="d-flex">
                            <p className="fs-20 color-black font-weight-600 margin-auto">Remaining Amount</p>
                          </div>
                          <div className="d-flex m-t-16">
                            <p className="fs-34 color-red font-weight-800 margin-auto">₹ {billingInfo.remainingAmount}</p>
                          </div>
                          <div className="d-flex m-t-24">
                            <div onClick={toggleInputFields('payment-due-date')} className={`${currentElementId == "payment-due-date" || closeEnqDetails.paymentDueDate ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} margin-auto`} style={{ border: currentElementId == "payment-due-date" || closeEnqDetails.paymentDueDate ? "1px solid var(--darkBlue)" : "", width:"40%" }}>
                              <div className="flex-item d-flex w-full">
                                <p className="placeholder-txt flex-item margin-auto" style={{ fontSize: currentElementId === "payment-due-date" || closeEnqDetails.paymentDueDate ? "10px" : "14px", color: currentElementId == "payment-due-date" || closeEnqDetails.paymentDueDate ? "var(--darkBlue)" : "", transition: "180ms" }}>Payment Due Date <span className="color-red">*</span></p>
                              </div>
                              <div className={`${currentElementId == "payment-due-date" || closeEnqDetails.paymentDueDate ? "active-input-field" : "inactive-input-field"} d-flex flex-item m-t-22`} style={{width:"92%"}}>
                                <input className="flex-item" id="payment-due-date" value={formatDateTime(closeEnqDetails.paymentDueDate)} placeholder="DD/MM/YYYY" style={{width:"100%", textAlign:"center"}} type="text" />
                              </div>
                            </div>  
                          </div>
                          <div className="d-flex m-t-30">
                            <p className="margin-auto color-red fs-18 font-weight-700">Are you sure you want to close this enquiry ?</p>
                          </div>
                          <div className="d-flex m-t-12">
                            <div className="flex-item d-flex margin-auto">
                              <div onClick={cancelCloseEnquiry} className="flex-item d-flex member-button-global m-r-12">
                                <p className="flex-item">No</p>
                              </div>
                              <div onClick={()=>isButtonLock?null:handleCloseEnquiry()} className={`flex-item d-flex member-button-global ${isButtonLock?'global-blue-button-controller-inactive':'global-blue-button-controller-active'}`}>
                                <p className="flex-item">Yes</p>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    ) : (
                      <div className="bottom-action-button">
                        <div onClick={isButtonLock?null:checkAndCloseEnquiry} className={`member-button-global btn-center d-flex ${isButtonLock ? "member-button-global-inactive" : "global-blue-button-controller-active"}`} style={{ width: "100%", height:"40px", borderRadius:"20px" }}>
                          <p className="flex-item">Submit</p>
                        </div>
                      </div>
                    )
                  }

                </div>
              )
            }
          </div>
        </div>
      </div>
    </div>
  ) 
}

export default CloseEnquiry;